var map = {
	"./Auth/Login.vue": 6300,
	"./Backoffice/Blogs/Create.vue": 8982,
	"./Backoffice/Blogs/Edit.vue": 5947,
	"./Backoffice/Blogs/Index.vue": 1407,
	"./Backoffice/Candidates/Index.vue": 4589,
	"./Backoffice/Candidates/Show.vue": 5869,
	"./Backoffice/Dashboard.vue": 4340,
	"./Backoffice/Faq/Create.vue": 9970,
	"./Backoffice/Faq/Edit.vue": 9300,
	"./Backoffice/Faq/Index.vue": 3552,
	"./Backoffice/Messages/Index.vue": 1318,
	"./Backoffice/Messages/Show.vue": 9517,
	"./Backoffice/PositionCategories/Create.vue": 2673,
	"./Backoffice/PositionCategories/Edit.vue": 6555,
	"./Backoffice/PositionCategories/Index.vue": 2734,
	"./Backoffice/Positions/Create.vue": 6089,
	"./Backoffice/Positions/Edit.vue": 3633,
	"./Backoffice/Positions/Index.vue": 8068,
	"./Blogs/Index.vue": 3582,
	"./Blogs/Show.vue": 3628,
	"./Careers/Index.vue": 4074,
	"./Careers/Show.vue": 6210,
	"./Company/About.vue": 3345,
	"./Company/ClarificationText.vue": 5476,
	"./Company/CommercialProcedure.vue": 8094,
	"./Company/ConsentText.vue": 3538,
	"./Company/CookiePolicy.vue": 2579,
	"./Company/CustomerIdentification.vue": 3999,
	"./Company/Declaration.vue": 7488,
	"./Company/Legal.vue": 7397,
	"./Company/Partners.vue": 9238,
	"./Company/PrivacyPolicy.vue": 8485,
	"./Company/ProtectionOfPersonalData.vue": 7407,
	"./Company/Team.vue": 3331,
	"./Company/TermsOfUse.vue": 9611,
	"./Contact/Index.vue": 6177,
	"./Custom/xwgt.vue": 597,
	"./Dashboard.vue": 4013,
	"./Error.vue": 604,
	"./Finance/Index.vue": 641,
	"./Gaming/Development.vue": 1459,
	"./Gaming/GameHub.vue": 3524,
	"./Gaming/GameStore.vue": 8638,
	"./Gaming/Hosting.vue": 9791,
	"./Gaming/Incubation.vue": 3771,
	"./Gaming/Marketplace.vue": 7716,
	"./Gaming/XWGT.vue": 2201,
	"./Platform/Apis.vue": 6503,
	"./Platform/Build.vue": 8851,
	"./Platform/Nodes.vue": 1879,
	"./whitelist/thankyou.vue": 9742
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1230;